import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';

@Component({
  selector: 'app-exit-edit-story-dialog',
  standalone: true,
  imports: [],
  templateUrl: './exit-edit-story-dialog.component.html',
  styleUrl: './exit-edit-story-dialog.component.scss'
})
export class ExitEditStoryDialogComponent {
  // create reference to dialog and pass the data type to pass to parent component when dialog is closed (boolean) to trigger save or cancel
  dialogRef = inject<DialogRef<boolean>>(DialogRef<boolean>);
  data = inject(DIALOG_DATA);
}
